export default __webpack_public_path__ + "static/media/xpla-vertical.d0ed04f5.svg";